import React, { useState, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Button, Table, Alert, Spinner, Form, InputGroup, Card } from 'react-bootstrap'
import { useAdminDataAccesses } from 'api/hooks/use-admin-data-accesses'

const DataAccessesList = () => {
  const { data: dataAccesses, isLoading, error } = useAdminDataAccesses()
  const [searchTerm, setSearchTerm] = useState('')

  const filteredDataAccesses = useMemo(() => {
    if (!dataAccesses) return []
    return dataAccesses.filter((da) => {
      const term = searchTerm.toLowerCase()
      return (
        da.name?.toLowerCase().includes(term) ||
        da.description?.toLowerCase().includes(term) ||
        da.category?.toLowerCase().includes(term) ||
        da.top_module_name?.toLowerCase().includes(term)
      )
    })
  }, [dataAccesses, searchTerm])

  if (isLoading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    )
  }

  if (error) {
    return <Alert variant="danger">Error loading data accesses: {error.message}</Alert>
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Data Accesses</h2>
        <Button as={Link} to="/admin/data-accesses/new" variant="primary">Create Data Access</Button>
      </div>

      <Card className="mb-4">
        <Card.Body>
          <InputGroup>
            <InputGroup.Text>Search</InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search by name, description, category, or module..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </Card.Body>
      </Card>

      <div className="mb-3">
        <strong>Showing {filteredDataAccesses.length} of {dataAccesses?.length || 0} data accesses</strong>
      </div>

      <Table bordered hover responsive>
        <thead>
          <tr>
            <th>Category</th>
            <th>Name</th>
            <th>Description</th>
            <th>Access Type</th>
            <th>Top Module</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredDataAccesses.map((da) => (
            <tr key={da.id}>
              <td><code>{da.category}</code></td>
              <td>{da.name || '-'}</td>
              <td>{da.description?.substring(0, 60)}{da.description?.length > 60 ? '...' : ''}</td>
              <td>{da.access_type || '-'}</td>
              <td>{da.top_module_name || '-'}</td>
              <td>
                <Button as={Link} to={`/admin/data-accesses/${da.id}`} variant="info" size="sm" className="me-2">View</Button>
                <Button as={Link} to={`/admin/data-accesses/${da.id}/edit`} variant="warning" size="sm">Edit</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {filteredDataAccesses.length === 0 && <Alert variant="info">No data accesses found.</Alert>}
    </div>
  )
}

export default DataAccessesList
